import { useCallback } from 'react'
import { toast } from 'react-toastify'

import { ErrorResponse } from '@makyoapp/makyo-sdk/api/api'

import { formatError } from '@/lib/error'

import useAuth from './useAuth'

export function useReqError() {
  const { logout } = useAuth()
  return useCallback(
    (err: string | ErrorResponse | Error) => {
      const { message, status } = formatError(err)

      if (import.meta.env.DEV) {
        console.error(err)
      }

      if (status === 401) {
        logout()
      } else if (message?.toLowerCase()?.includes('unauthorized')) {
        return
      } else {
        toast.dismiss('for-all')
        toast.error(message, {
          containerId: 'for-all',
        })
      }
    },
    [logout]
  )
}
